import { render, staticRenderFns } from "./AllBusinessAnnualReturnsSubmissions.vue?vue&type=template&id=228c0fdd&scoped=true&"
import script from "./AllBusinessAnnualReturnsSubmissions.vue?vue&type=script&lang=js&"
export * from "./AllBusinessAnnualReturnsSubmissions.vue?vue&type=script&lang=js&"
import style0 from "./AllBusinessAnnualReturnsSubmissions.vue?vue&type=style&index=0&id=228c0fdd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c0fdd",
  null
  
)

export default component.exports